import cardStockId from "./card-stock/id";
import stockAdjustmentId from "./stock-adjustment/id";

import stockInId from "./stock-in/id";
import stockOutId from "./stock-out/id";
import stockTransferId from "./stock-transfer/id";

const inventoryId = {
	inventory: {
		...cardStockId,
		...stockInId,
		...stockOutId,
		...stockTransferId,
		...stockAdjustmentId,
	},
};

export default inventoryId;
